import * as Yup from "yup";

export const formSchema = Yup.object().shape({
    firstName: Yup.string()
        .min(2, 'Imię jest za krótkie.')
        .max(50)
        .matches(/^[\p{L} ]+$/gu, 'Podaj prawidłowe imię.'),
    email: Yup
        .string()
        .email('Ta wartość nie jest prawidłowym adresem email.')
        .max(255)
        .required('Ta wartość nie powinna być pusta.'),
    newsletterAgreement: Yup.boolean().oneOf([true],'To pole jest obowiązkowe'),
    newsletter_info: Yup.boolean().oneOf([true],'To pole jest obowiązkowe'),
    statute: Yup.boolean().oneOf([true],'To pole jest obowiązkowe'),
});
    // .test('allChecked', 'Zaznacz wszystkie pola', function (values) {
    // if (
    //     (values.newsletterAgreement || values.newsletter_info || values.statute) &&
    //     !(values.newsletterAgreement && values.newsletter_info && values.statute)
    // ) {
    //     return this.createError({
    //         path: 'statute',
    //         message: 'Zaznacz pozostałe pola',
    //     });
    // }

